'use client';

import React, { FC, useEffect, useRef, useState } from 'react';

export interface optionItems {
  name: string | React.ReactNode;
  val?: string;
  link?: boolean;
  target?: string;
}

interface Props {
  btnName: React.ReactNode;
  option?: Array<optionItems>;
  type?: string;
  optionWidth?: string;
  className?: string;
  selected?: string;
  onChange?: Function;
  disabled?: boolean;
  style?: Object;
}

interface OptionPosition {
  width: string | undefined;
  top?: string | undefined;
  bottom?: string | undefined;
  left: string | undefined;
}

/**
 *
 * @param btnName 버튼명
 * @param option 옵션 [{name: 'btn', val: 'val', link: 'link', target: 'link target'}]
 * @param type 드롭다운 type
 * @param optionWidth 옵션박스 너비
 * @param className 추가 클래스
 * @param selected 선택 옵션 val
 * @param onChange 체인지 콜백
 * @param disabled 비활성
 * @param style style
 * @returns Dropdown
 */
const Dropdown: FC<Props> = (props) => {
  const {btnName, option, type = "1", optionWidth, className, selected, onChange, disabled, style} = props;

  const [isOpen, setIsOpen] = useState(false);
  const [optionStyle, setOptionStyle] = useState<OptionPosition>({
    width: undefined,
    left: undefined,
    top: undefined,
    bottom: undefined
  });
  const [btnTxt, setBtnTxt] = useState(btnName);
  const [value, setValue] = useState(
    option && selected !== null ? selected : null
  );
  const outerRef = useRef<HTMLDivElement>(null);

  const optionShow = () => {
    if(isOpen == false) {
      const elRect: any = outerRef.current?.getBoundingClientRect();

      const style: OptionPosition = {
        width: (optionWidth) ? optionWidth : `${elRect.width}px`,
        top: `${elRect.top + elRect.height}px`,
        left: `${elRect.left}px`,
      }

      setOptionStyle(style);
    }
    setIsOpen(true);
  }
  const optionHide = (event?: Event) => {
    if (outerRef.current && (event?.target === window || !outerRef.current.contains(event?.target as Node))) {
      setIsOpen(false);
    }
  }
  const toggleMenu = () => {
    (isOpen == false) ? optionShow() : optionHide();
  };
  const optionChange = (obj: {name: string, val: string}) => {
    setValue(obj.val);
    optionHide();
    if (typeof btnName === 'string') setBtnTxt(obj.name);
    if (onChange) onChange(obj.val);
  };

  useEffect(() => {
    if (isOpen) {
      window.addEventListener('click', optionHide);
      document.querySelector('.ki-main-contents')?.addEventListener('scroll', optionHide);
      window.addEventListener('resize', optionHide);
    }
    return () => {
      window.removeEventListener('click', optionHide);
      document.querySelector('.ki-main-contents')?.removeEventListener('scroll', optionHide);
      window.removeEventListener('resize', optionHide);
    };
  }, [isOpen]);

  return <div
    className={`dropdown__box dropdown__type-${type} ${className || ''}`}
    ref={outerRef}
    style={style}
  >
    <button
      type="button"
      className={`dropdown__btn${isOpen ? ' isOpen' : ''}${value ? ' isSelected' : ''}`}
      onClick={toggleMenu}
      disabled={disabled}
    ><span className="inner">{btnTxt}</span></button>
    {isOpen &&
    <div className="dropdown__option" style={optionStyle}>
      <RenderOption
        option={option}
        selectVal={value}
        onChange={optionChange}
      />
    </div>}
  </div>
}
export default Dropdown;

const RenderOption: FC<{ option: any; selectVal?: any; onChange: Function }> = ({
  option,
  selectVal,
  onChange,
}) => {
  const [current, setCurrent] = useState(selectVal ? selectVal : null);
  const handleOptionClick = (val: string) => {
    setCurrent(val);
    if(onChange) onChange(val);
  };
  useEffect(() => {
    if(selectVal) setCurrent(selectVal);
  }, [selectVal]);

  return <div className="dropdown__option__inner">
    {option.map((item: any, idx: number) => {
      return (
        <div
          className={`option${item.val == current && item.val != null ? ' isCurrent' : ''}${item.clsnm ? ` ${item.clsnm}`: ''}`}
          key={idx}
        >
          {item.val && <button
            type="button"
            className="btn"
            onClick={() => handleOptionClick(item)}
          >{item.name}</button>}
          {item.link && <a 
            href={item.link}
            className="btn"
            target={(item.target) ? item.target : '_self'}
          >{item.name}</a>}
        </div>
      );
    })}
  </div>
}